const normalizeSegment = (value: string): string => {
  return value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9_-]+/g, '-')
    .replace(/^-+|-+$/g, '');
};

const randomSegment = (): string => {
  if (typeof globalThis !== 'undefined' && globalThis.crypto?.randomUUID) {
    return globalThis.crypto.randomUUID().replace(/-/g, '').slice(0, 12);
  }

  return Math.random().toString(36).slice(2, 14);
};

export function generateId(
  prefix = 'id',
  ...segments: Array<string | number | null | undefined>
): string {
  const safePrefix = normalizeSegment(prefix) || 'id';
  const safeSegments = segments
    .map((segment) => {
      if (segment === null || segment === undefined) {
        return '';
      }

      return normalizeSegment(String(segment));
    })
    .filter(Boolean);

  const timestamp = Date.now().toString(36);
  return [safePrefix, ...safeSegments, timestamp, randomSegment()].join('-');
}
